<script setup lang="ts"></script>

<template>
  <div class="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-bg-app">
    <!-- 径向光晕装饰 -->
    <div
      class="pointer-events-none absolute inset-0"
      style="
        background:
          radial-gradient(circle at 20% 10%, rgba(6, 182, 212, 0.16), transparent 45%),
          radial-gradient(circle at 85% 90%, rgba(37, 99, 235, 0.14), transparent 45%);
      "
    />
    <div class="relative z-10 w-full">
      <slot />
    </div>
  </div>
</template>
